import { Content } from "../../types/content.interface";

export const experienceData: Content[] = [
  {
    enSubtitle: "Software Maestro 13th - Selected as the best person (TOP 8%)",
    krSubtitle: "소프트웨어 마에스트로 13기 - 우수자 선정 (상위 8%)",
    enSubDescription: "Backend of app services, Business planning",
    krSubDescription: "앱 서비스 백엔드 개발, 사업 기획",
    isDisplay: true,
    details: [
      {
        linkUrl: "https://ddakzip.com/download",
        linkText: "link",
        enText:
          "Project on 'DDAKZIP' Backend, AWS infra setting & APIs development with Typescript+GraphQL",
        krText:
          "'딱집' 프로젝트 백엔드 담당, AWS로 인프라를 세팅하고, Typescript+GraphQL로 API를 개발했습니다.",
        date: "(22.04 ~ 22.11)",
        isDisplay: true,
      },
      {
        enText:
          "Focused on writing clean APIs so that front developers can use it easily.",
        krText:
          "프론트개발자가 사용하기 쉽도록 깔끔한 API 작성에 집중했습니다.",
        isDisplay: true,
      },
      {
        enText:
          "Experience various parts such as project planning, design, marketing, etc",
        krText: "프로젝트 기획, 디자인, 마케팅 등 다양한 파트를 경험했습니다.",
        isDisplay: true,
      },
      {
        enText:
          "Improve performance with repectoring and automate cloud deployment with terraform when projects are over",
        krText:
          "프로젝트가 끝났을 때, 리펙토링을 통해 성능 개선 및 테라폼으로 클라우드 배포 자동화",
        isDisplay: true,
      },
    ],
  },
];
